import { render } from "./updateMember.vue?vue&type=template&id=3c8be745&scoped=true"
import script from "./updateMember.vue?vue&type=script&lang=js"
export * from "./updateMember.vue?vue&type=script&lang=js"

import "./updateMember.vue?vue&type=style&index=0&id=3c8be745&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8be745"]])

export default __exports__